import './bootstrap';
import { hidePageLoading, showPageLoading } from './components/loading';
import Tooltip from 'bootstrap/js/dist/tooltip';
import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm';

window.Alpine = Alpine;
Livewire.start();

// Font Awesomeをインポート
import '@fortawesome/fontawesome-free/css/all.min.css';

// 同一オリジンの a タグクリック時にローダーを表示
document.addEventListener('click', (event) => {
  const link = event.target.closest(`a[href^="${window.location.origin}"], a[href^="//"]`);
  if (!link) {
    return;
  }
  if (link.target === '_blank') {
    return;
  }
  if (link.dataset.loader === 'disabled') {
    return;
  }
  const href = link.getAttribute('href');
  if (!href || href.startsWith('javascript:')) {
    return;
  }
  if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
    return;
  }
  showPageLoading();
  if (link.dataset.loader === 'timeout') {
    setTimeout(function () {
      hidePageLoading();
    }, 2000);
  }
});
// init bootstrap tooltip
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
[...tooltipTriggerList].map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));

// フォーム送信ボタン
document.querySelectorAll('.js-main-form-submit').forEach((button) => {
  button.addEventListener('click', () => {
    const form = document.getElementById('main-form');
    if (!form) {
      return;
    }
    form.requestSubmit();
  });
});

// ボタンのクリックイベント
const copyToClipboard = (e) => {
  const text = e.dataset.text;
  if (!text) return;
  navigator.clipboard.writeText(text);
  const toast = document.getElementById('js-copy-toast');
  if (!toast) return;
  toast.classList.add('is-show');
  setTimeout(() => {
    toast.classList.remove('is-show');
  }, 2000);
};
document.addEventListener('DOMContentLoaded', () => {
  const copyButton = document.querySelectorAll('.js-copy-btn');
  copyButton.forEach((button) => {
    button.addEventListener('click', () => {
      copyToClipboard(button);
    });
  });
});
